/* global __APP_VERSION__, __APP_BUILD_DATE__ */
import { useEffect, useState } from "react"
import { useAtom } from "jotai"
import Modal from "./Modal"
import api from "../services/api"
import { userAtom, isSuperAdminAtom, isOrgAdminAtom, isGuideAdminAtom, isGuideAtom } from "../state"
import { useUserOrganization } from "../hooks/useUserOrganization"

function DebugModal({ isOpen, setIsOpen }) {
  const [user] = useAtom(userAtom)
  const [isSuperAdmin] = useAtom(isSuperAdminAtom)
  const [isOrgAdmin] = useAtom(isOrgAdminAtom)
  const [isGuideAdmin] = useAtom(isGuideAdminAtom)
  const [isGuide] = useAtom(isGuideAtom)
  const organization = useUserOrganization()

  const [apiVersion, setApiVersion] = useState(null)
  const [apiVersionError, setApiVersionError] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    setLoading(true)
    setApiVersionError(null)
    api
      .getVersion()
      .then(response => setApiVersion(response.data))
      .catch(() => setApiVersionError("Failed to load API version"))
      .finally(() => setLoading(false))
  }, [isOpen])

  const adminFlags = [
    isSuperAdmin && "super_admin",
    isOrgAdmin && "org_admin",
    isGuideAdmin && "guide_admin",
    isGuide && "guide",
  ]
    .filter(Boolean)
    .join(", ")

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} width="md:max-w-xl">
      <h2 className="mb-4 text-xl font-bold">Debug Info</h2>

      <section className="mb-4">
        <h3 className="mb-1 font-semibold">Client</h3>
        <p>Version: {__APP_VERSION__}</p>
        <p>Built: {__APP_BUILD_DATE__}</p>
      </section>

      <section className="mb-4">
        <h3 className="mb-1 font-semibold">API</h3>
        {loading && <p>Loading...</p>}
        {apiVersionError && <p className="text-red-600">{apiVersionError}</p>}
        {apiVersion && (
          <>
            <p>Version: {apiVersion.short_sha ?? "unknown"}</p>
            <p>Built: {apiVersion.committed_at ?? "unknown"}</p>
            <p>Environment: {apiVersion.environment}</p>
            <p>Sentry release: {apiVersion.sentry_release ?? "none"}</p>
          </>
        )}
      </section>

      <section>
        <h3 className="mb-1 font-semibold">Session</h3>
        {user ? (
          <>
            <p>User ID: {user.id}</p>
            <p>Organization: {organization?.name ?? organization?.id ?? "none"}</p>
            <p>Admin flags: {adminFlags || "none"}</p>
          </>
        ) : (
          <p>Not logged in</p>
        )}
      </section>
    </Modal>
  )
}

export default DebugModal
